export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";